import {bool, date, object, string} from 'yup';
import {COUNTRIES_UPPERCASE} from '../../../../../constants/countries';
import {fileSchema} from "../../../FormHandlers";

const countriesIds = COUNTRIES_UPPERCASE.map((el) => el[1])

export default object({
  account_holder_full_name: string().trim().required(),
  account_holder_birthdate: date().required(),
  account_holder_country_of_residence: string().required().oneOf(countriesIds),
  account_holder_country_of_birth: string().required().oneOf(countriesIds),
  account_holder_identity_doc: string().trim().required(),

  account_holder_document_identity: fileSchema,
  account_holder_document_address: fileSchema,

  account_holder_is_director: bool().default(false),

  director_full_name: string().trim().required().when('holder_is_director', {
    is: true,
    then: () => string(),
  }),
  director_birthdate: date().required().when('holder_is_director', {
    is: true,
    then: () => date(),
  }),
  director_country_of_residence: string().required().oneOf(countriesIds).when('holder_is_director', {
    is: true,
    then: () => string(),
  }),
  director_country_of_birth: string().required().oneOf(countriesIds).when('holder_is_director', {
    is: true,
    then: () => string(),
  }),
  director_identity_doc: string().trim().required().when('holder_is_director', {
    is: true,
    then: () => string(),
  }),
  director_document_identity: object().when('holder_is_director', {
    is: (holder_is_director) => !!holder_is_director,
    then: () => string(),
    otherwise: () => fileSchema
  }),
  director_document_address: object().when('holder_is_director', {
    is: (holder_is_director) => !!holder_is_director,
    then: () => string(),
    otherwise: () => fileSchema
  }),
})
